import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Http from '../../config/axiosUtils';
import { replaceTel } from '../../utils/validate';
import ChangePayPwd from '../../components/personal/ChangePayPwd';
import AuthCode from '../../components/common/AuthCode';
import '../../assets/scss/Personal/authInput.scss';

class AuthInput extends Component {
  constructor() {
    super();
    this.state = {
      pwdError: false,
      mobile: '',
      authCode: '',
      isSend: false
    }
  }

  componentDidMount() {
    this.setState({
      mobile: this.props.userInfo.mobile
    })
    this.onHandlePhone();
  }

  pwdSureBack = (value) => {
    this.setState({
      authCode: value
    })
  }

  nextStep = async () => {
    const path = '/spread/web/authCode/simpleCheck';
    const postData = {
      authCode: this.state.authCode,
      mobile: this.props.userInfo.mobile,
      type: 12
    }
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      this.props.pwdSuccess(this.state.authCode);
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  onHandlePhone = async () => {
    const path = '/spread/web/authCode/send';
    const postData = {
      mobile: this.props.userInfo.mobile,
      type: 12,
    }
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      Toast.hide();
      this.setState({
        isSend: true
      })
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  onSuccessSend = () => {
    this.setState({
      isSend: false
    })
  }

  render () {
    return (
      <div>
        <ChangePayPwd
          title='输入短信验证码'
          subTitle={`我们已发送短信验证码到您的手机号${replaceTel(this.state.mobile)}，请注意查收`}
          pwdError={this.state.pwdError}
          pwdSureBack={this.pwdSureBack}
          nextStep={this.nextStep}
          btnTitle='下一步'>
        </ChangePayPwd>
        <div className='authInput'>
          <AuthCode isSend={this.state.isSend} isHighColor={true} onHandlePhone={this.onHandlePhone} onSuccessSend={this.onSuccessSend}></AuthCode>
        </div>
      </div>
    )
  }
}

AuthInput.propTypes = {
  pwdSuccess: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo
  }
}

export default connect(mapStateToProps)(AuthInput);